import { render, staticRenderFns } from "./PersonAddQuad.vue?vue&type=template&id=5bf13282&scoped=true"
import script from "./PersonAddQuad.vue?vue&type=script&lang=js"
export * from "./PersonAddQuad.vue?vue&type=script&lang=js"
import style0 from "./PersonAddQuad.vue?vue&type=style&index=0&id=5bf13282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf13282",
  null
  
)

export default component.exports